var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShareCalendar = function SvgIconShareCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 4.25a.625.625 0 0 0-.625.625V6.75H2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h15c.69 0 1.25-.56 1.25-1.25V8c0-.69-.56-1.25-1.25-1.25h-1.25V4.875a.625.625 0 0 0-.625-.625h-1.25a.625.625 0 0 0-.625.625V6.75h-7.5V4.875a.625.625 0 0 0-.625-.625h-1.25ZM16.25 13H3.75v5.625c0 .345.28.625.625.625h11.25c.345 0 .625-.28.625-.625V13Z",
    fill: "#4E6DF5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.143,
    cy: 5.857,
    r: 5.714,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.901 7.808h-2.828v2.898H17.59V7.808h-2.828V6.464h2.828V3.566h1.484v2.898h2.828v1.344Z",
    fill: "#4E6DF5"
  })));
};
export default SvgIconShareCalendar;